export default __webpack_public_path__ + "66b78a6305a6b908f0e0ae854dd18fa7.jpg";